import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";

export const Faq = () => {
  const { t } = useLang();
  return (
  <section id="faq" data-testid="faq-section" className="py-24 lg:py-40 bg-[#0c100e]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="lg:col-span-4"
      >
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-12 bg-[#c5a059]" />
          <span className="text-[11px] tracking-[0.4em] uppercase text-[#c5a059]">{t.faq.label}</span>
        </div>
        <h2 className="font-serif-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-[#f0f4f2]">
          {t.faq.title.pre}<span className="italic text-[#c5a059]">{t.faq.title.it}</span>{t.faq.title.post}
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="lg:col-span-8"
      >
        <Accordion type="single" collapsible className="w-full">
          {t.faq.items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="border-white/10 py-2"
            >
              <AccordionTrigger className="font-serif-display text-xl sm:text-2xl text-[#f0f4f2] hover:text-[#c5a059] hover:no-underline text-left transition-colors duration-300 [&>svg]:text-[#c5a059]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-[#8a9690] font-light leading-relaxed max-w-2xl pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
  );
};
